import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=7e186bf8&scoped=true"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"
import style0 from "./add-product.vue?vue&type=style&index=0&id=7e186bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e186bf8",
  null
  
)

export default component.exports